// extendable keyboard layouts object
import i18n from '@app/localization/i18n';

export default {
    normal: {
        _meta: {
            tab: {
                key: '\t',
                text: 'Tab',
                width: 60,
                classes: 'control',
            },
            shiftl: {
                keySet: 'shifted',
                text: 'Shift',
                width: 100,
                classes: 'control',
            },
            shiftr: {
                keySet: 'shifted',
                text: 'Shift',
                width: 100,
                classes: 'control',
            },
            caps: {
                keySet: 'capsed',
                text: '⇪ Caps Lock',
                width: 20,
            },
            space: {
                key: ' ',
                text: 'Space',
                width: 60,
                classes: 'control',
            },
            backspace: {
                func: 'backspace',
                text: '',
                classes: 'control backspace',
                width: 65,
            },
            accept: {
                func: 'accept',
                text: 'OK',
                classes: 'control featured',
                width: 20,
            },
            next: {
                func: 'next',
                text: 'Next',
                classes: 'control featured',
            },
            close: {
                func: 'cancel',
                text: i18n.t('close'),
                classes: 'control featured',
                width: 60
            },
        },
        default: [
            '` 1 2 3 4 5 6 7 8 9 0 =',
            'q w e r t y u i o p ( ) {close}',
            'a s d f g h j k l ; \' {backspace}',
            '. @ z x c v b n m , -',
            '{caps} {space} {accept}',
        ],
        shifted: [
            '~ ! / # $ % ^ & * { } +',
            'Q W E R T Y U I O P [ ] {close}',
            'A S D F G H J K L : " {backspace}',
            '< > Z X C V B N M ? _',
            '{caps} {space} {accept}',
        ],
        capsed: [
            '~ ! / # $ % ^ & * { } +',
            'Q W E R T Y U I O P [ ] {close}',
            'A S D F G H J K L : " {backspace}',
            '< > Z X C V B N M ? _',
            '{caps} {space} {accept}',
        ],
    },
    numeric: {
        _meta: {
            backspace: {
                func: 'backspace', text: '', classes: 'control',
            },
            accept: {
                func: 'accept', text: 'OK', classes: 'control featured', width: '66',
            },
            clear: {
                func: 'cancel', text: 'DEL', classes: 'control', width: '32',
            },
            zero: { key: '0' },
        },
        default: [
            '1 2 3',
            '4 5 6',
            '7 8 9',
            '. {zero} {backspace}',
            '{clear} {accept}',
        ],
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/poland/app/localization/lang/translations/keyboardLayouts.ts